module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.9a71d861.woff";